import NavbarItem from "./NavbarItem";

export default function NavbarRight(props) {
  return (
    <div className="navbar-right">
      <ul>
        {props.links.map((section, i) => {
          return (
            <NavbarItem
              route={section.target}
              content={section.label}
              key={i}
              button={section.button}
              leftIcon={section.leftIcon}
              rightIcon={section.rightIcon}
              username={section.username}
              logout={section.logout}
            />
          );
        })}
      </ul>
    </div>
  );
}
